// extracted by mini-css-extract-plugin
export default {"breakpointContent":"1120px","breakpointTablet":"1039px","breakpointTabletMobile":"744px","breakpointMobile":"575px","breakpointTinyMobile":"368px"};